import { useMutation } from '@apollo/client';
import { LearnerObject_OccupationInputType as learnerObjectOccupationInputType } from '__generated__/graphql-types';

import LearnerObjectUpdateCurrentOccupationMutation from 'bundles/onboarding-common/queries/LearnerObjectUpdateCurrentOccupation.graphql';
import type {
  LearnerObject_UpdateCurrentOccupationMutation as LearnerObjectUpdateCurrentOccupationMutationType,
  LearnerObject_UpdateCurrentOccupationMutationVariables as LearnerObjectUpdateCurrentOccupationMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectUpdateCurrentOccupation';

const useLearnerObjectUpdateCurrentOccupation = () => {
  const [updateCurrentOccupationMutation] = useMutation<
    LearnerObjectUpdateCurrentOccupationMutationType,
    LearnerObjectUpdateCurrentOccupationMutationVariables
  >(LearnerObjectUpdateCurrentOccupationMutation, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateCurrentOccupation = async (currentOccupation: Record<string, string>) => {
    let occupation: string;
    let occupationInputType: learnerObjectOccupationInputType;

    if (currentOccupation.id) {
      occupation = currentOccupation.id;
      occupationInputType = learnerObjectOccupationInputType.Defined;
    } else {
      // Account for user clearing the field by sending an empty string
      occupation = currentOccupation.otherText ?? '';
      occupationInputType = learnerObjectOccupationInputType.UserGenerated;
    }

    const variables: LearnerObjectUpdateCurrentOccupationMutationVariables = {
      input: {
        currentOccupation: {
          occupation,
          occupationInputType,
        },
      },
    };

    const { data, errors } = await updateCurrentOccupationMutation({ variables });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (
      data?.LearnerObject_UpdateCurrentOccupation?.__typename === 'LearnerObject_UpdateCurrentOccupationResultError'
    ) {
      return { success: false, errors: [data.LearnerObject_UpdateCurrentOccupation.message] };
    }

    return { success: true, errors: [] };
  };

  return { updateCurrentOccupation };
};

export default useLearnerObjectUpdateCurrentOccupation;
